var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"form",class:{ 'd-flex': _vm.flex },scopedSlots:_vm._u([{key:"default",fn:function({ invalid }){return [_vm._t("default",null,{"invalid":invalid,"onValidate":_vm.onValidate})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }